import * as Yup from 'yup';

export const validate = Yup.object().shape({
    nombre: Yup.string().required('campo obligatorio'),
    descripcion: Yup.string().required('campo obligatorio'),
  });